import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import MatrikkelSearchEvents from '../MatrikkelSearchEvents.js'
import VisIcon from '../../../images/submenu_open copy 6.png'
import NavigateIcon from '../../../images/submenu_open copy 5.png'
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'
import WarningIcon from '../../../images/advarsel2.png'

class Seksjon extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleSeksjon = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    navigateSeksjon = (event) => {
        event.stopPropagation()
        this.props.onMatrikkelObjectSelected({
            domainKlasse: "Matrikkelenhet",
            matrikkelenhet: this.props.seksjon
        })
    }

    showSeksjon = (event) => {
        event.stopPropagation()
        this.props.onEvent({
            type: MatrikkelSearchEvents.ShowObject,
            data: {
                type: MatrikkelSearchEvents.ShowSeksjon,
                seksjon: this.props.seksjon
            }
        })
    }

    render() {
        const { t } = this.props
        var seksjon = this.props.seksjon
        var matrikkelnummer = `${seksjon.gardsnummer}/${seksjon.bruksnummer}`;
        if (seksjon.festenummer || seksjon.seksjonsnummer) matrikkelnummer += `/${seksjon.festenummer}/${seksjon.seksjonsnummer}`;
        var infoList = []
        if (seksjon.utgatt) infoList.push(t('utgatt'))
        if (!seksjon.harTeig) infoList.push(t('manglerteig'))
        var formal = seksjon.formalseksjonkode ? ` - ${seksjon.formalseksjonkode.substr(seksjon.formalseksjonkode.indexOf('-')+2)}` : "";

        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleSeksjon}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{seksjon.kommuneId}-{matrikkelnummer}{formal}</span>
                    { infoList.length > 0 &&
                    <div className="icon-image tooltip warning">
                        <img src={WarningIcon} />
                        <div className="tooltip-content">
                            {infoList.map((i, index) => { return (<div key={index}>{i}</div>) })}
                        </div>
                    </div> }
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                    <div className="icon-image right tooltip" onClick={this.navigateSeksjon}>
                        <img className="tool" src={NavigateIcon} />
                        <div className="tooltip-content">{t('naviger.seksjon')}</div>
                    </div>
                    { seksjon.harTeig &&
                    <div className="icon-image right tooltip" onClick={this.showSeksjon}>
                        <img className="tool" src={VisIcon} />
                        <div className="tooltip-content">{t('vis.seksjon')}</div>
                    </div> }
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('kommune')}</div>
                            <div className="value">{seksjon.kommunenavn} ({seksjon.kommuneId})</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('eiendom')}</div>
                            <div className="value">{matrikkelnummer}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('formal')}</div>
                            <div className="value">{seksjon.formalseksjonkode}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Seksjon)